const features = [
  {
    icon: 'ri-4k-line',
    title: '真4K超清画质',
    desc: '原生4K HDR片源，每一帧都是视觉享受，远超普通高清画质',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载不缓冲',
    desc: '全球68个CDN节点 + 智能码率适配技术，观影流畅不卡顿',
    color: 'bg-accent-100 text-accent-700',
  },
  {
    icon: 'ri-film-line',
    title: '海量高清片库',
    desc: '超过12,000部影片，涵盖全类型，每日持续更新最新内容',
    color: 'bg-emerald-100 text-emerald-600',
  },
  {
    icon: 'ri-device-line',
    title: '全设备无缝观影',
    desc: '电脑、平板、手机全端支持，网页即开即看，APP离线缓存',
    color: 'bg-amber-100 text-amber-700',
  },
  {
    icon: 'ri-shield-check-line',
    title: '清爽安全体验',
    desc: '观影过程无打扰，不存储任何视频文件，保障用户隐私安全',
    color: 'bg-rose-100 text-rose-600',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <div className="inline-flex items-center gap-2 bg-accent-100/80 px-4 py-2 rounded-full mb-5">
              <i className="ri-medal-line text-accent-600 text-sm"></i>
              <span className="text-accent-700 text-xs font-medium">为什么选择我们</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              平台优势
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              麻花影院用心打造每一个观影细节，只为给你最好的体验
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
            {features.map((feature) => (
              <div key={feature.title} className="group bg-background-50 border border-background-200/70 rounded-xl p-6 text-center hover:border-primary-200/70 hover:-translate-y-0.5 transition-all duration-300">
                <div className={`w-14 h-14 rounded-2xl ${feature.color} flex items-center justify-center mx-auto mb-4`}>
                  <i className={`${feature.icon} text-2xl`}></i>
                </div>
                <h3 className="font-heading text-foreground-900 font-semibold text-sm mb-2">
                  {feature.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}